import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueCarousel from 'vue-carousel';
import vPagination from 'vue-plain-pagination';


// @import: Font awesome icons
import {config, library} from "@fortawesome/fontawesome-svg-core";
import {
  faArchive,
  faArrowDown,
  faArrowUp,
  faCaretUp,
  faChair,
  faCheckSquare,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faClone,
  faExclamation,
  faFileAlt,
  faFileExport,
  faHeart as heartSolid,
  faInfo,
  faLink,
  faMinus,
  faPlus,
  faSearch,
  faSortDown,
  faTh,
  faThLarge,
  faThList,
  faThumbtack,
  faTimes,
  faTrashAlt,
  faUserSecret,
  faUserTie
} from "@fortawesome/free-solid-svg-icons";
import {faHeart as hearOutline, faSquare as regularSquare} from "@fortawesome/free-regular-svg-icons";
import {faFacebookF, faPinterestP, faTwitter} from "@fortawesome/free-brands-svg-icons";

// @do: Configure fontawesome icons and add to library
config.autoAddCss = false;
library.add(
    faTh,
    faThLarge,
    faThList,
    hearOutline,
    heartSolid,
    faSearch,
    faTimes,
    faChevronUp,
    faChevronRight,
    faChevronLeft,
    faFacebookF,
    faTwitter,
    faPinterestP,
    faLink,
    faCheckSquare,
    regularSquare,
    faCircle,
    faInfo,
    faThumbtack,
    faUserTie,
    faSortDown,
    faUserSecret,
    faPlus,
    faClone,
    faArchive,
    faTrashAlt,
    faFileExport,
    faChair,
    faFileAlt,
    faArrowUp,
    faArrowDown,
    faExclamation,
    faCaretUp,
    faMinus
);

Vue.use(VueCarousel);

Vue.use(vPagination);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
